import { render } from "./Octicon.vue?vue&type=template&id=13d2da78"
import script from "./Octicon.vue?vue&type=script&lang=js"
export * from "./Octicon.vue?vue&type=script&lang=js"

import "./Octicon.vue?vue&type=style&index=0&id=13d2da78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__